import React from "react";

const AuthorRoles = () => {
  return (
    <React.Fragment>
      <h1>Author Roles, etc.</h1>

      <p>
        In general, authors cannot be added or removed after manuscript submission. However, upon
        special request, we may consider such a change after extensive scrutiny. In-progress article
        submissions can be withdrawn at the author's request for resubmission with authorship
        changes. If Preferred Editing was purchased for the initial submission, no refund will be
        provided, and an additional purchase will be required upon resubmission. No changes in
        authorship are permitted under any circumstance after manuscript publication.
      </p>

      <h2>
        <strong>Submitting Author</strong>
      </h2>
      <p>
        The submitting author is responsible for the submission, peer review, and publication
        process. Only the submitting author can edit the article, author names, contributions, and
        affiliations. All CJBE email notifications sent during the submission process will be sent
        to the submitting author. For these reasons, we strongly recommend that authors submit their
        own work.
      </p>
      <p>
        The submitting author is also responsible for confirming potential conflicts of interest on
        behalf of all authors and ensuring compliance with ethical guidelines.
      </p>

      <h2>
        <strong>Corresponding Author</strong>
      </h2>
      <p>
        The submitting author may designate a co-author to serve as the corresponding author after
        the article is published. All the correspondence during the peer review process will be
        primarily done with the submitting author. Please note that the corresponding author does
        not have edit access. However, all correspondence on the published article (queries on data
        availability, research method, etc.) would be the sole responsibility of the corresponding
        author. If required, an editor can correspond with all authors.
      </p>

      <h2>
        <strong>Shared First Authorship</strong>
      </h2>
      <p>
        CJBE does not support co-first authorship. If you wish to recognize two or more first
        authors, please include a statement to that effect in the Acknowledgments section.
      </p>

      <h2>
        <strong>AI Chatbots (Large Language Models)</strong>{" "}
      </h2>
      <p>
        Large Language Models (LLMs) such as OpenAI's ChatGPT or Google’s Gemini remains ineligible
        for article authorship. This is because authorship entails accountability for the work, and
        AI tools cannot assume such responsibility. Authors using LLM tools should document the
        usage in the Research Method or Acknowledgements sections. Articles written entirely by an
        LLM tool will not be accepted.
      </p>
    </React.Fragment>
  );
};

export default AuthorRoles;
